export const sgConfig = {
    taxOfficeName: 'IRAS',
    deliveryTaxOfficeQuestionTag: 'IRAS',
    searchPlaceholder: "Search taxpayers using names, Atlas ID or GTS ID...",
    taxId: "FIN/NRIC",
};
